export function redact(str) {
  const splitted = str.split('\n')
  const roles = splitted.map(r => r.split('-').at(-1))

  const namesOnly = splitted.map(r => r.replace(' -' + r.split('-').at(-1), '')).slice(0, -1)
  return namesOnly.map((r, i) => r.split(/-| /).map(k => k.at(0) + k.at(1) + '.').join(' ') + ' - ' + roles[i])
}